import axios from "axios";

axios.defaults.timeout = 300000; // 设置下载请求的超时时间为300秒


//获取项目数据列表
export const postLoadHealthTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/selectNormalTable",
        data:params
    })
}

//小程序获取长者
export const postLoadHealthTableXcx= (emId,params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/selectNormalTableXcx/"+emId,
        data:params
    })
}

//获取待办高龄补贴老人（一个月内）
export const postLoadGlbtTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/selectGlbtTable",
        data:params
    })
}

export const postMzjg= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/selectMzjg",
        data:params
    })
}

//提交登记
export const postHandleRegister= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/add",
        data:params
    })
}

//提交登记
export const postHandleRegisterSq= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/addSq",
        data:params
    })
}

//保存信息
export const postHandleUpdate= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/upd",
        data:params
    })
}

export function getLoadProject(){
    return axios({
        method:'GET',
        url:'/system-ya/project/all',
    })
}

export function getLoadAgedTypes(){
    return axios({
        method:'POST',
        url:'/system-ya/aged/type/list',
    })
}

export function getLoadAgedStandards(){
    return axios({
        method:'POST',
        url:'/system-ya/aged/standard/list',
    })
}

export function getLoadFamilies(){
    return axios({
        method:'GET',
        url:'/system-ya/family/list',
    })
}

//获取省
export function getGetProvinces(){
    return axios({
        method:'GET',
        url:'/system-ya/regionInfo/selectProvince',
    })
}

export const getNextLevel= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/regionInfo/selectCity/'+params
    })
}

//编辑
export const getHandleLoadData= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/aged/info/'+params
    })
}

//删除
export const getHandleDelAged= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/aged/remove/'+params
    })
}


export function getLoadAgeds(){
    return axios({
        method:'POST',
        url:'/system-ya/aged/list',
    })
}

export function getLoadOffers(){
    return axios({
        method:'POST',
        url:'/system-ya/provider/list',
    })
}

export function getLoadWorkOrderContents(){
    return axios({
        method:'POST',
        url:'/system-ya/wo/content/list',
    })
}

export function getLoadSeatInfo(){
    return axios({
        method:'POST',
        url:'/system-ya/edb/status',
    })
}

export function getGetCurrentEm(){
    return axios({
        method:'GET',
        url:'/system-ya/em/getCurrentEm',
    })
}

//获取aaa
export function getGetJianTin(){
    return axios({
        method:'GET',
        url:'/system-ya/AAA/aaa',
    })
}


export function getAgedAbility(){
    return axios({
        method:'POST',
        url:'/system-ya/agedAbility/list',
    })
}

export function getAgedCategory(){
    return axios({
        method:'POST',
        url:'/system-ya/agedCategory/list',
    })
}

export const importTemp= () => {
    return axios({
        method:'post',
        url: "/system-ya/aged/import/temp",
        dataType: "text",
    })
}


export const PhonePeiZhiAGED= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/api/nbiot/selectNbPhone/'+params
    })
}

export const upDataNbPhoneAGED= (params,params1) =>{
    return axios({
        method:'GET',
        url:'/system-ya/api/nbiot/upDataNbPhone/'+params+"/"+params1
    })
}

export const postLoadWoTableExcelAGED= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/user/excelAll",
        data:params,
        responseType:'blob'
    })
}

export const postLoadWoReportExcelAGED= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/user/downAgedServiceExcel",
        data:params,
        responseType:'blob'
    })
}

export const postExportWorkMoneyExcel= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/user/exportWorkMoneyExcel",
        data:params,
        responseType:'blob'
    })
}

export const loaDexcelAgedDownloadExcel= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/user/excelAgedDownloadExcel",
        data:params,
        responseType:'blob'
    })
}

export function importAction(){
    return axios({
        method:'post',
        url:"/system-ya/aged/import",
        responseType:'blob'
    })
}

export function downFileCPK(name){
    return axios({
        method:'get',
        url:"/system-ya/yaProductFile/downFile/" + name,
        responseType:'blob'
    })
}


export function downFileChanPin(name){
    // 对文件名进行编码
    return axios({
        method: 'get',
        url: '/system-ya/yaProductFile/downFile',
        params: { fileName: name }, // 使用 query 参数传递
        responseType: 'blob'
    });
}


export function exportExcelEvaluate(name){
    return axios({
        method:'get',
        url:"/system-ya/user/exportExcelEvaluate/" + name,
        responseType:'blob'
    })
}